var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 1.422c2.133 0 2.4 0 3.2.09.8 0 1.245.177 1.511.266.356.178.622.355.889.622s.444.533.622.889c.09.267.267.711.267 1.511 0 .8.089 1.067.089 3.2s0 2.4-.09 3.2c0 .8-.177 1.244-.266 1.511a3.192 3.192 0 01-.622.889 3.192 3.192 0 01-.889.622c-.267.09-.711.267-1.511.267-.8 0-1.067.089-3.2.089s-2.4 0-3.2-.09c-.8 0-1.244-.177-1.511-.266A3.192 3.192 0 012.4 13.6a3.192 3.192 0 01-.622-.889c-.09-.267-.267-.711-.267-1.511 0-.8-.089-1.067-.089-3.2s0-2.4.09-3.2c0-.8.177-1.244.266-1.511.178-.356.355-.622.622-.889.267-.356.533-.533.889-.622.267-.09.711-.267 1.511-.267.8-.089 1.067-.089 3.2-.089zM8 0C5.867 0 5.511 0 4.711.089c-.889 0-1.422.178-1.955.355a3.48 3.48 0 00-1.423.89 3.48 3.48 0 00-.889 1.422C.178 3.289.09 3.822.09 4.71 0 5.511 0 5.867 0 8s0 2.489.089 3.289c0 .889.178 1.422.355 1.955.178.534.445.978.89 1.423a3.48 3.48 0 001.422.889c.533.177 1.066.355 1.955.355C5.511 16 5.867 16 8 16s2.489 0 3.289-.089c.889 0 1.422-.178 1.955-.355a3.48 3.48 0 001.423-.89 3.48 3.48 0 00.889-1.422c.177-.533.355-1.066.355-1.955S16 10.133 16 8s0-2.489-.089-3.289c0-.889-.178-1.422-.355-1.955a3.48 3.48 0 00-.89-1.423 3.48 3.48 0 00-1.422-.889C12.711.267 12.178.09 11.29.09 10.489 0 10.133 0 8 0zm0 3.911C5.689 3.911 3.911 5.69 3.911 8A4.078 4.078 0 008 12.089 4.078 4.078 0 0012.089 8 4.078 4.078 0 008 3.911zm0 6.756C6.489 10.667 5.333 9.51 5.333 8S6.49 5.333 8 5.333 10.667 6.49 10.667 8 9.51 10.667 8 10.667zm4.267-7.911a.986.986 0 00-.978.977c0 .534.444.978.978.978a.986.986 0 00.978-.978.987.987 0 00-.978-.977z",
      "fill": "#fff"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }